import React, { useState } from 'react'
import { CCol, CRow } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilChevronBottom, cilChevronTop } from '@coreui/icons'
import './table.css'
import { wtRoundNumberToSpecifedDigits } from 'src/helpers/commons/utils'
import { Link } from 'react-router-dom'
import { wtConvertHourValue } from 'src/helpers/commons/moment'

export default function DataReportTable({ reportData,
  formatDate,
}) {
  const [sortedKey, setSortedKey] = useState('')
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc',
  })

  const sortTable = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    const sorted = [...reportData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'asc' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'asc' ? 1 : -1
      }
      return 0
    })
    setReportData(sorted)
    setSortedKey(key)
    setSortConfig({ key, direction })
  }

  const getDifference = (record) => {
    let { working_hours, updated_working_hours, shift_duration, is_holiday } = record

    if (is_holiday) {
      shift_duration = 0;
    }

    if (updated_working_hours !== null) {
      return wtRoundNumberToSpecifedDigits(Math.abs(updated_working_hours - shift_duration) * 60, 2,) + ' min'
    }
    else if (working_hours !== null) {
      return wtRoundNumberToSpecifedDigits(Math.abs(working_hours - shift_duration) * 60, 2,) + ' min'
    }
    else {
      return '-'
    }
  }

  const getDifferenceColor = (record) => {
    const { working_hours, updated_working_hours, shift_duration, is_holiday } = record
    if (is_holiday) {
      return 'green'
    }

    if (updated_working_hours !== null) {
      if (updated_working_hours > shift_duration) {
        return 'green'
      }
      else if (updated_working_hours < shift_duration) {
        return 'red'
      }
      else {
        return 'blue'
      }
    }
    else if (working_hours !== null) {
      if (working_hours > shift_duration) {
        return 'green'
      }
      else if (working_hours < shift_duration) {
        return 'red'
      }
      else {
        return 'blue'
      }
    }
    else {
      return 'blue'
    }
  }

  const DESIGNATION_TYPE_NAMES = {
    1: 'Staff',
    2: 'Worker',
    3: 'Daily Wager'
  };
  const getAttendanceStatus = (item) => item.is_updated ? item.updated_type : item.type;
  return (
    <CRow>
      <CCol md={12}>
        <table className="table table-bordered data-table">
          <thead class="thead-dark" style={{ backgroundColor: '#e8e9eb' }}>
            <tr>
              <th onClick={() => sortTable('id')}>Sr</th>
              <th onClick={() => sortTable('id')}>
                ID{' '}
                {sortedKey === 'id' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('full_name')}>
                Full Name
                {sortedKey === 'full_name' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>

              <th onClick={() => sortTable('designation.name')}>
                Designation
                {sortedKey === 'designation.name' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('designation.is_officer')}>
                Type
                {sortedKey === 'designation.is_officer' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('department.name')}>
                Department
                {sortedKey === 'department.name' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>

              <th onClick={() => sortTable('attendance_date')}>
                Attendance Date
                {sortedKey === 'attendance_date' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('type')}>
                Attendance Status
                {sortedKey === 'type' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('check_in')}>
                Check In
                {sortedKey === 'check_in' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('check_out')}>
                Check Out
                {sortedKey === 'check_out' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('late_coming')}>
                Late Coming
                {sortedKey === 'late_coming' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('early_going')}>
                Early Going
                {sortedKey === 'early_going' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('working_hours')}>
                Working Hours
                {sortedKey === 'working_hours' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('shift_duration')}>
                Shift Duration
                {sortedKey === 'shift_duration' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th>Difference</th>
              <th onClick={() => sortTable('ovetime_hours')}>
                Overtime Hours
                {sortedKey === 'ovetime_hours' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th>Approved Overtime</th>
            </tr>
          </thead>
          <tbody>
            {reportData.map((item, index) => {
              const attendanceStatus = getAttendanceStatus(item)
              return (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td style={{ color: 'blue' }}>
                  <Link
                    to={`/employee-profile?id=${item.employee_id}&tab=emp_attendance`}
                    target="_blank"
                  >
                    {item.employee.id}
                  </Link>
                </td>
                <td style={{ color: 'blue' }}>
                  <Link
                    to={`/employee-profile?id=${item.employee_id}&tab=emp_attendance`}
                    target="_blank"
                  >
                    {item.employee.full_name}
                  </Link>
                </td>
                <td>{item.employee.designation.name}</td>
                <td>
                  {item.employee.designation.is_officer === 1
                    ? 'Officer'
                    : DESIGNATION_TYPE_NAMES[item.employee.designation.type]
                  }
                </td>
                <td>{item.employee.department.name}</td>
                <td>{formatDate(item.attendance_date)}</td>
                <td>{getAttendanceStatus(item) || '-'}</td>

                {attendanceStatus !== 'Public Holiday' && attendanceStatus !== 'Weekly Holiday' && attendanceStatus !== 'On Move' && attendanceStatus !== 'Leave' ? (
                  <>
                    <td style={{ color: 'blue' }}>{item.is_updated ? item.updated_check_in : item.check_in}</td>
                    <td style={{ color: 'blue' }}>{item.is_updated ? item.updated_check_out : item.check_out}</td>

                    <td style={{ color: 'red', textAlign: 'center' }}>
                      {item.is_updated ? wtRoundNumberToSpecifedDigits(item.updated_late_coming) + ' min' : item.late_coming ? wtRoundNumberToSpecifedDigits(item.late_coming) + ' min' : '-'}
                    </td>
                    <td style={{ color: 'red', textAlign: 'center' }}>
                      {item.is_updated ? wtRoundNumberToSpecifedDigits(item.updated_early_going) + ' min' : item.early_going ? wtRoundNumberToSpecifedDigits(item.early_going) + ' min' : '-'}
                    </td>
                    <td>{wtConvertHourValue(item.is_updated ? item.updated_working_hours : item.working_hours)}</td>
                    <td>{wtConvertHourValue(item.shift_duration)}</td>
                    <td
                      style={{ color: getDifferenceColor(item) }}
                    >{getDifference(item)}</td>
                    <td style={{ color: item.overtime_hours ? 'green' : 'red' }}>{item.overtime_hours ? wtRoundNumberToSpecifedDigits(item.overtime_hours > 0 ?? 0) + ' Hours' : '-'} </td>

                    <td style={{ color: item.is_overtime_approved === 0 ? 'red' : 'green' }}>
                      {item.is_overtime_approved === 0 ? '-' : (item.updated_overtime_hours ? wtRoundNumberToSpecifedDigits(item.updated_overtime_hours > 0 ?? 0) + ' Hours' : '-')}
                    </td>


                  </>
                ) : (
                  <td colSpan={9} style={{ textAlign: 'center', color: 'blue' }}>{attendanceStatus !== 'Public Holiday' ? attendanceStatus : item.remarks}</td>
                )}

              </tr>
            )})}
          </tbody>
        </table>
      </CCol>
    </CRow>
  )
}
